import React from 'react';
import { OfficeBranch } from '@moxie/shared';

const OfficeBranchList: React.FC = () => {
  return <OfficeBranch />;
};

export default OfficeBranchList;
